  <div class="row">
    <div class="col-12">
      <div class="gb-headline2 mt-6 mb-5" *ngIf="category.title">{{ category.title }}</div>
      <div *ngFor="let planCard of category.planCard">
          <webu-plan-card [planCard]="planCard" [orderIdMap]="orderIdMap" [type]="category.type"></webu-plan-card>
      </div>
    </div>
  </div>